// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nAjA","field":"styles_field__23oja","fieldCol":"styles_fieldCol__292P9","diffCol":"styles_diffCol__uH3Uv","diff":"styles_diff__3l8WI"};